import { StockApi } from '../../../api/Purchase/Stock'
import Stock from '../../../components/Purchasing/Stock/Stock'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useTitle from '../../../elements/Hooks/useTitle'
import React from 'react'

function StockCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => StockApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('Stock')

  const propsProps = {
    list,
    fetching,
    fetch,
    company,
    onChangeCompany,
  }

  return <Stock {...propsProps} />
}

export default StockCont
